<template>
    <div class="transparent-button" @click="goToLink(link)">
        <p>{{text}}</p>
    </div>
</template>

<script>
    import EventBus from "../main";

    export default {
        name: "ButtonWithTransparent",
        props: ['text', 'link','callback'],
        methods: {
            goToLink(value) {
                if (value === '#') {
                    EventBus.$emit('menu-status');
                    this.$router.push({name: 'Home'});
                } else if (value === "_fn") {
                    this['callback']();
                } else {
                    window.open(value);
                }
            }
        }
    }
</script>

<style lang="scss">
    .transparent-button {
        width: 233px;
        height: 44px;
        min-width: 100px;
        display: flex;
        text-decoration: none;
        color: white;
        padding: 5px 0;
        border: 1px solid white;
        border-radius: 150px;
        background-color: rgba(255,255,255,0);
        text-transform: uppercase;
        text-align: center;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        p {
            width: 99px;
            height: 15px;
            font-family: "Quicksand", sans-serif, Tahoma;
            font-size: 12px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #ffffff;
        }
    }
</style>